/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useEffect } from 'react'; // Moves the placement of the active cell

export var useMoveActiveCell = function useMoveActiveCell(_ref) {
  var spreadsheetRef = _ref.spreadsheetRef,
      activeCellCoordinates = _ref.activeCellCoordinates,
      containerHasFocus = _ref.containerHasFocus,
      createActiveCell = _ref.createActiveCell;
  useEffect(function () {
    var activeCellPlacementElement = spreadsheetRef === null || spreadsheetRef === void 0 ? void 0 : spreadsheetRef.current.querySelector("[data-row-index=\"".concat(activeCellCoordinates === null || activeCellCoordinates === void 0 ? void 0 : activeCellCoordinates.row, "\"][data-column-index=\"").concat(activeCellCoordinates === null || activeCellCoordinates === void 0 ? void 0 : activeCellCoordinates.column, "\"]"));
    var shouldPlaceActiveCellInHeader = (activeCellCoordinates === null || activeCellCoordinates === void 0 ? void 0 : activeCellCoordinates.row) === 'header' && true;
    var selectAllElement = spreadsheetRef === null || spreadsheetRef === void 0 ? void 0 : spreadsheetRef.current.querySelector("[data-row-index=\"header\"][data-column-index=\"header\"]");

    if (containerHasFocus) {
      createActiveCell({
        placementElement: activeCellCoordinates ? activeCellPlacementElement : selectAllElement,
        coords: activeCellCoordinates,
        addToHeader: shouldPlaceActiveCellInHeader
      });
    }
  }, [activeCellCoordinates, spreadsheetRef, createActiveCell, containerHasFocus]);
};